//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Myelodysplastic_syndrome",
  data() {
    return {
      form: {
        limb: "",
        breath: "",
        loop: "",
        state: "",
        bloodOxygen: "",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "0", name: "极好" },
        { value: "1", name: "好" },
        { value: "2", name: "中等" },
        { value: "3", name: "差" },
        { value: "4", name: "极差" },
      ],
      dataList2: [
        { value: "0", name: "≤2" },
        { value: "1", name: "＞2~＜5" },
        { value: "2", name: "5~10" },
        { value: "3", name: "＞10" },
      ],
      dataList3: [
        { value: "0", name: "≥100" },
        { value: "1", name: "80~＜100" },
        { value: "1.5", name: "＜80" },
      ],
      dataList4: [
        { value: "0", name: "≥100" },
        { value: "0.5", name: "50~＜100" },
        { value: "1", name: "＜50" },
      ],
      dataList5: [
        { value: "0", name: "≥0.8" },
        { value: "0.5", name: "＜0.8" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Myelodysplastic_syndrome.vue